module.exports = __webpack_public_path__ + "static/startups-bg-0c1504ab9a5b5752f8364210bd3a8c99.jpg";